export const checkValidVATNumber = async (
  country: string,
  taxNumber: string,
) => {
  if (taxNumber.length < 5 || !country) return false;

  const url =
    process.env['NODE_ENV'] !== 'production'
      ? `http://localhost:3000/api/check-vat?country=${country}&vatNumber=${taxNumber}`
      : `https://${process.env['NEXT_PUBLIC_VERCEL_URL']}/api/check-vat?country=${country}&vatNumber=${taxNumber}`;

  try {
    const checkValidVat = await fetch(url, {
      cache: 'force-cache',
    });
    const validVat = await checkValidVat.json();
    return validVat.isValid;
  } catch (error) {
    console.error(error);
    return false;
  }
};
